import {
	Button, Collapse,TextField,
	//Collapse, Typography, Card, CardContent,
} from "@mui/material"
import {useEffect, useRef, useState} from "react"
import axios from "axios"

export default function AuthorInviteInput({inviteKey, setInviteKey, open}) {
	const [showKeyInput, setShowKeyInput] = useState(open || false)
	const [validKeyCheck, setValidKeyCheck] = useState(false)
	const [invalidKeyMsg, setInvalidKeyMsg] = useState("")
	const keyInputFocusRef = useRef(null)

	const validateKeyInput = (inputValue) => {
		axios.get(`/api/license/validate/${inputValue}`)
			.then((res) => {
				if(res.status === 200) {
					setValidKeyCheck(true)
					setInvalidKeyMsg("")
				}
			})
			.catch((axiosRes) => {
				console.error("KEY DID NOT VALIDATE: ", axiosRes)
				const { response } = axiosRes
				if(response.status === 403) {
					setInvalidKeyMsg("This key is invalid. It may have been mistyped, used, or revoked. Please contact the sender of this key")
				} else {
					setInvalidKeyMsg("Something went wrong attempting to validate this key, try again or contact the sender of the key")
				}
				setValidKeyCheck(false)
			})
	}

	const handleInput = (event) => {
		setInviteKey(event.target.value)
		if(event.target.value.length >= 30) {
			validateKeyInput(event.target.value.trim())
		} else if (inviteKey && invalidKeyMsg) {
			setInvalidKeyMsg("This does not appear to be a normal key, did you copy the correct value?")
		}
	}

	useEffect(() => {
		if(showKeyInput) {
			keyInputFocusRef.current.focus()
		}
	}, [showKeyInput])

	return (
		<>
			<Button
				variant="outlined"
				onClick={() => setShowKeyInput(!showKeyInput)}
				size={"large"}
				sx={{
					height: "3.5rem",
					width: "100%"
				}}
			>
				Have an access code?
			</Button>
			<Collapse in={showKeyInput}>
				<TextField
					sx={{
						marginTop: "1rem"
					}}
					onKeyDown={(e) => e.stopPropagation()}
					fullWidth
					className="tunedTextField"
					id="invitekey"
					label="Invite Code"
					onChange={handleInput}
					value={inviteKey}
					inputRef={keyInputFocusRef}
					error={inviteKey && inviteKey.length > 3 && !validKeyCheck}
					helperText={inviteKey && inviteKey.length > 3 && !validKeyCheck ? invalidKeyMsg : ""}
				/>
			</Collapse>
		</>
	)
}